import styled from "@emotion/styled";
import { FadeInContent } from "./FadeInContent";
import { Italic } from "./Italic";
import { Swiper, SwiperSlide } from "swiper/react";
import { Modal } from "./Modal";
import "swiper/css";
import "swiper/css/pagination";
import "./Gallery.css";
import "swiper/css/navigation";
import { fadeIn } from "../style/ani";
import { useEffect, useState } from "react";
import { child, get, getDatabase, push, ref, set } from "firebase/database";
import { fireBaseApp } from "../db/db";
import { setImageLikes } from "../utils/utils";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper";
import {isMobile} from 'react-device-detect';


const setImage = async () => {
  const db = getDatabase(fireBaseApp);
  await set(ref(db, "imgs"), {
    img01: {
      id: "img01",
      src: "/selected/GWA01117.jpeg",
      likes: 0,
    },
    img02: {
      id: "img02",
      src: "/selected/GWA07884.jpeg",
      likes: 0,
    },
    img00: {
      id: "img00",
      src: "/selected/GWA00720.jpeg",
      likes: 0,
    },
    img04: {
      id: "img04",
      src: "/selected/GWA09003.jpeg",
      likes: 0,
    },
    img05: {
      id: "img05",
      src: "/selected/GWA01470.jpeg",
      likes: 0,
    },
    img06: {
      id: "img06",
      src: "/selected/GWA09985.jpeg",
      likes: 0,
    },
    img07: {
      id: "img07",
      src: "/selected/GWA02205.jpeg",
      likes: 0,
    },
     img08: {
      id: "img08",
      src: "/selected/GWA07349.jpeg",
      likes: 0,
    },
    img09: {
      id: "img09",
      src: "/selected/GWA00695.jpeg",
      likes: 0,
    },
    img10: {
      id: "img10",
      src: "/selected/GWA09497.jpeg",
      likes: 0,
    },
    img11: {
      id: "img11",
      src: "/selected/GWA00018.jpeg",
      likes: 0,
    },
    img12: {
      id: "img12",
      src: "/selected/GWA00038.jpeg",
      likes: 0,
    },
    // img13: {
    //   id: "img13",
    //   src: "/selected/GWA00059.jpeg",
    //   likes: 0,
    // },
    // img14: {
    //   id: "img14",
    //   src: "/selected/GWA01689.jpeg",
    //   likes: 0,
    // },
    // img15: {
    //   id: "img15",
    //   src: "/selected/GWA02015.jpeg",
    //   likes: 0,
    // },
    // img16: {
    //   id: "img16",
    //   src: "/selected/GWA02073.jpeg",
    //   likes: 0,
    // },
    // img17: {
    //   id: "img17",
    //   src: "/selected/GWA02216.jpeg",
    //   likes: 0,
    // },
    // img18: {
    //   id: "img18",
    //   src: "/selected/GWA02229.jpeg",
    //   likes: 0,
    // },
    // img19: {
    //   id: "img19",
    //   src: "/selected/GWA06910.jpeg",
    //   likes: 0,
    // },
    // img20: {
    //   id: "img20",
    //   src: "/selected/GWA07309.jpeg",
    //   likes: 0,
    // },
    // img21: {
    //   id: "img21",
    //   src: "/selected/GWA07383.jpeg",
    //   likes: 0,
    // },
    // img22: {
    //   id: "img22",
    //   src: "/selected/GWA07407.jpeg",
    //   likes: 0,
    // },
    // img23: {
    //   id: "img23",
    //   src: "/selected/GWA07517.jpeg",
    //   likes: 0,
    // },
    // img24: {
    //   id: "img24",
    //   src: "/selected/GWA07693.jpeg",
    //   likes: 0,
    // },
    // img25: {
    //   id: "img25",
    //   src: "/selected/GWA07721.jpeg",
    //   likes: 0,
    // },
    // img26: {
    //   id: "img26",
    //   src: "/selected/GWA08454.jpeg",
    //   likes: 0,
    // },
    // img27: {
    //   id: "img27",
    //   src: "/selected/GWA08468.jpeg",
    //   likes: 0,
    // },
    // img28: {
    //   id: "img28",
    //   src: "/selected/GWA08965.jpeg",
    //   likes: 0,
    // },
    // img29: {
    //   id: "img29",
    //   src: "/selected/GWA09426.jpeg",
    //   likes: 0,
    // },
    // img30: {
    //   id: "img30",
    //   src: "/selected/GWA09429.jpeg",
    //   likes: 0,
    // },
    // img31: {
    //   id: "img31",
    //   src: "/selected/GWA09698.jpeg",
    //   likes: 0,
    // },
})
};



const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
  gap: 10px;
  width: 100%;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right:20px;
  overflow: hidden;
`;

const SliderImage = styled.div`
  /* background-image: url(/sea.jpg); */
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  height: 50vh;
  width: 480px;
  animation: ${fadeIn} 1s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const ModalImage = styled.div`
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  animation: ${fadeIn} 0.5s ease-in-out;
  display: flex;
`;

// 자, 로컬에서 이미지를 가지고 있어야 하나 아니면 이미지 까지 서버에서 주어야 하냐,
// 정리해 보면,

// imgs/ -> img1 -> src, likes
// imgs/ -> img2 -> src, likes
// imgs/ -> img3 -> src, likes

const getImages = async () => {
  const snapshot = await get(child(ref(getDatabase(fireBaseApp)), "imgs"));
  const imgs = snapshot.val();
  return imgs;
};

const likeImage = async (img: any) => {
  // await set(ref(db, `imgs/${img.id}`), {
  //   id: img.id,
  //   src: img.src,
  //   likes: img.likes + 1,
  // });
  
  await setImageLikes(img.id, img.src, img.likes + 1);
 
};

const GalleryImage = ({
  img,
  setModalSrc,
  setModalOpen,
  setModalIndex,
}: {
  img: { src: string; likes: number; id: string };
  setModalSrc: (src: string) => void;
  setModalOpen: (open: boolean) => void;
  setModalIndex: () => void;
}) => {
  const [liked, setLiked] = useState(false);
  const [likesNumber, setLikesNumber] = useState(img.likes);

  const checkLiked = () => {
    const liked = localStorage.getItem(img.id);
    if (liked) {
      setLiked(true);
    }
  };

  const setLikedLocalStorage = () => {
    localStorage.setItem(img.id, "true");
  };

  useEffect(() => {
    checkLiked();
    // setImage();
  }, []);

  return (
    <SliderImage
      // style={{ backgroundImage: `url(${img.src})` }}
      onClick={() => {
        setModalSrc(img.src);
        setModalIndex();
        setModalOpen(true);
      }}
    >
      <img src={`${img.src}`}
      style={{width:"100%", height:"100%", objectFit:"contain"}}
      alt="" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          width: "100%",
          padding: "10px",
          position: "absolute",
          bottom: "0",
          left: "0",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (liked) {
              return;
            } else {
              likeImage(img);
              setLikesNumber((prev) => prev + 1);
              setLiked(true);
              setLikedLocalStorage();
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              color: "pink",
              backgroundColor: "rgba(0,0,0,0.5)",
              padding: "5px",
              paddingTop: "3px",
              paddingBottom: "3px",
              borderRadius: "5px",
            }}
          >
            {liked ? "♥" : "♡"}
            <div
              style={{
                color: "white",
                fontSize: "14px",
              }}
            >
              {likesNumber}
            </div>
          </div>
        </div>
      </div>
    </SliderImage>
  );
};

const BigImgModal = ({
  modalOpen,
  setModalOpen,
  activeImg,
}: {
  modalSrc: string;
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  activeImg: { src: string; likes: number; id: string };
}) => {
  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        setModalOpen(false);
      }}
    >
      <ModalImage
      >
        <img
          style={{width: "100%", height: "100%", objectFit: "contain"}}
          src={activeImg.src}
          alt="img"
        />
      </ModalImage>
    </Modal>
  );
};

export function Gallery() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSrc, setModalSrc] = useState("/sea.jpg");
  const [modalIndex, setModalIndex] = useState(0);
  const [imgs, setImgs] = useState<any[]>();

  useEffect(() => {
    getImages().then((imgs) => {
      setImgs(Object.values(imgs).sort((a: any, b: any) => b.likes - a.likes));
    });
  }, []);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);


  return (
    <Container>
      <FadeInContent
        style={
          {marginBottom: "20px"}
        }
      >
        <Italic>- Gallery -</Italic>
      </FadeInContent>
      {/* <FadeInContent>
        <b>행복한 모습 좋아요 부탁해용~</b>
      </FadeInContent> */}

      <Swiper
        slidesPerView={1}
        navigation={true}
        spaceBetween={12}
        centeredSlides={true}
        modules={[FreeMode, Navigation, Thumbs]}
        thumbs={{ swiper: thumbsSwiper }}
        cssMode={ isMobile ? true : false}
      >
        {imgs &&
          imgs.map((img, i) => {
            return (
              <SwiperSlide key={img.id}>
                  <GalleryImage
                  img={img}
                  setModalSrc={setModalSrc}
                  setModalOpen={setModalOpen}
                  setModalIndex={() => {
                    setModalIndex(i);
                  }}
                />

              </SwiperSlide>
            );
          })}
      </Swiper>
      <Swiper
        //@ts-ignore
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={6}
        freeMode={true}
        navigation={true}
        watchSlidesProgress={true}
        modules={[ Navigation, Thumbs]}
        className="mySwiper"
        cssMode={ isMobile ? true : false}
      >
        {imgs &&
          imgs.map((img, i) => {
            return (
              <SwiperSlide key={`thumb${img.id}`}>
                 <div
                  style={{width: "100px", height: "50px", 
                  backgroundImage: `url(${img.src})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                 />
              </SwiperSlide>
            );
          })}

      </Swiper>

      {imgs && imgs[modalIndex] && (
        <BigImgModal
          modalSrc={modalSrc}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          activeImg={imgs[modalIndex]}
        />
      )}
    </Container>
  );
}
